import { z } from 'zod';
import { yesNoRequired } from '@utils/form-schema';

export const assessCancerSchema = z
    .object({
        hasHadCancer: yesNoRequired,
        cancers: z.array(
            z.object({
                cancerType: z.string(),
                remissionStatus: z.string(),
            }),
        ),
    })
    .superRefine((data, ctx) => {
        if (data.hasHadCancer !== '1') return;

        const hasAny = data.cancers.some((c) => c.cancerType);

        if (!hasAny) {
            ctx.addIssue({ code: 'custom', path: ['cancers', 0, 'cancerType'], message: 'Required' });
        }

        data.cancers.forEach((entry, i) => {
            if (entry.cancerType && !entry.remissionStatus) {
                ctx.addIssue({
                    code: 'custom',
                    path: ['cancers', i, 'remissionStatus'],
                    message: 'Required',
                });
            }
        });
    });
